import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import {
    DynamicHtmlDirective,
    LoginNavigationService,
    MediaQueryService,
    MessageLifetime,
    MessageQueueService,
    MessageType,
    NativeAppService,
    NavigationService,
    TrackingService,
    UserLoginEvent,
    UserService,
    ViewTemplateForClient,
    WindowRef,
} from '@frontend/vanilla/core';
import { LhHeaderBarComponent } from '@frontend/vanilla/features/header-bar';
import { MessagePanelComponent } from '@frontend/vanilla/features/message-panel';
import { NavigationLayoutPageComponent } from '@frontend/vanilla/features/navigation-layout';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

import { NewAccountMenuService } from '../services/account-menu-v2.service';
import { PortalNavigationService } from '../services/portal-navigation.service';
import { ScrollToService } from '../services/scrollTo.service';
import { PortalTrackingService } from './../tracking/tracking-resource.service';
import { EventNameConst, TrackingEvent } from './../tracking/tracking.model';
import { ContactResourceService } from './contact-resource.service';
import { HelpAndContactData, LinkTemplateItem } from './contact.models';
import { ContactOptionsComponent } from './parts/contact-options.component';
import { EmailOptionComponent } from './parts/email-option.component';

@Component({
    selector: 'pt-help-and-contact',
    templateUrl: 'help-and-contact.component.html',
    imports: [
        LhHeaderBarComponent,
        NgTemplateOutlet,
        NavigationLayoutPageComponent,
        EmailOptionComponent,
        FormsModule,
        DynamicHtmlDirective,
        NgClass,
        MessagePanelComponent,
        ContactOptionsComponent,
    ],
})
export class HelpAndContactComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() initData: any;
    @Input() content: ViewTemplateForClient;
    @Input() faqLink: LinkTemplateItem;
    @Input() twitterLink: LinkTemplateItem;
    deviceType: string;
    docUploadLink: LinkTemplateItem;
    faqPageLinks: LinkTemplateItem[];
    contactPageLinks: LinkTemplateItem[];
    isShown: boolean;
    selectedItem: any = null;
    subCategoryList: any[] = [];
    contentFaq: any = null;
    currentSelectedCategory: any = null;
    currentSelectedSubCategory: any = null;
    currentSelectedCategoryId: any = null;
    currentSelectedCategoryName: string = '';
    currentSelectedSubCatergoryId: any = null;
    selectedSubCategory: boolean = false;
    categorySelected: boolean = false;
    optionsScreen: boolean = false;
    helpAndContactData: HelpAndContactData;
    showEmail: boolean = false;
    showPhone: boolean = false;
    emailScreenContactData: any;
    phoneScreenContactData: any;
    loggedInUser: boolean;
    screenName: string;
    landingPage: string;
    subCategory: any = null;
    headerTitle: string;
    csMessage: string;
    v2NavEnabled: boolean = false;
    v2NavEnabledPreLogin: boolean = false;
    selectedSubCategoryId: any;
    isMobile: boolean = false;
    showchathistory: boolean = false;
    redirectedFromSASWFlow: boolean = false;
    private unsubscribe = new Subject<void>();
    constructor(
        private tracking: TrackingService,
        private navigation: NavigationService,
        private windowRef: WindowRef,
        private loginNavigationService: LoginNavigationService,
        private contactResourceService: ContactResourceService,
        private scrollService: ScrollToService,
        private user: UserService,
        private messageQueue: MessageQueueService,
        private activatedRoute: ActivatedRoute,
        private nativeAppService: NativeAppService,
        public newAccountMenuService: NewAccountMenuService,
        private mediaQueryService: MediaQueryService,
        private portalTrackingService: PortalTrackingService,
        private portalNavigation: PortalNavigationService,
    ) {
        this.helpAndContactData = new HelpAndContactData();
    }

    ngOnInit() {
        this.v2NavEnabled = this.newAccountMenuService.isNewAccountMenu();
        this.loggedInUser = this.user.isAuthenticated;
        this.isMobile = this.mediaQueryService.isActive('lt-sm');
        this.v2NavEnabledPreLogin =
            !this.v2NavEnabled || this.newAccountMenuService.isEpcotMenuEnabled() || (this.v2NavEnabled && !this.loggedInUser);
        this.headerTitle = this.initData.helpAndContactUxCleanUpEnabled
            ? this.initData.helpContactContent.messages.HeaderTitle
            : this.content.messages!.HeaderTitle;
        if (
            this.initData.helpAndContactUxCleanUpEnabled &&
            this.initData.csMessage !== null &&
            this.initData.csMessage !== undefined &&
            !this.isNullOrUndefined(this.initData.csMessage.text)
        ) {
            this.messageQueue.add(this.initData.csMessage.text, MessageType.Information, MessageLifetime.Single);
        }
        this.landingPage = JSON.parse(this.initData.landingPage);
        this.newAccountMenuService.scrollToTop();
        //this.initData.CSMessage
        if (this.landingPage[this.initData.playerPriority.toLowerCase()].toLowerCase() === 'contactoptionsscreen') {
            this.optionsScreen = true;
        }
        if (this.navigation.location.search.has('source')) {
            this.redirectedFromSASWFlow = this.navigation.location.search.get('source') === 'sasw' ? true : false;
            if (
                this.navigation.location.search.get('source') === 'documentupload' ||
                this.navigation.location.search.get('source') === 'email' ||
                this.navigation.location.search.get('source') === 'mohinterceptor'
            ) {
                this.optionsScreen = true;
            } else if (this.navigation.location.search.get('source') === 'registration' && this.optionsScreen !== true) {
                this.initData.newCategoriesList
                    .filter((category: any) => category.id === 'accountaccess')
                    .map((category: any) => {
                        category.checked = true;
                        this.selectedCategoryList(category);
                    });
            }
        }
        this.screenName = 'Section1';
        if (this.initData.csMessage !== undefined && this.initData.csMessage !== null && !this.isNullOrUndefined(this.initData.csMessage.text)) {
            this.capturePageLoadTracking('Help_Contact_HP_Section1_CSMessage');
        } else if (!this.optionsScreen && this.initData.newCategoriesList !== undefined && this.initData.newCategoriesList.length > 0) {
            this.capturePageLoadTracking('Help_Contact_HP_Section1');
        }

        this.user.events
            .pipe(
                first((e) => e instanceof UserLoginEvent),
                takeUntil(this.unsubscribe),
            )
            .subscribe(() => {
                this.contactResourceService.getPostLoginRedirectOverrideContidionUsnj().subscribe((response) => {
                    const isOverrideenWorkflow: boolean = response;
                    if (
                        this.navigation.location.absUrl().indexOf(this.portalNavigation.normalizeUrl('/contact')) > 0 &&
                        isOverrideenWorkflow &&
                        this.user.workflowType == 0
                    )
                        this.windowRef.nativeWindow.location.reload();
                });
            });

        if (this.activatedRoute.snapshot.params['category']) {
            this.initData.newCategoriesList
                .filter((category: any) => this.activatedRoute.snapshot.params['category'] == category.id)
                .map((category: any) => {
                    category.checked = true;
                    this.selectedCategoryList(category);
                });
        }

        if (this.navigation.location.search.get('source')) {
            const source = this.navigation.location.search.get('source') || '';
            this.goToContactOptions(source);
        }
        if (this.initData.enableChatHistory && this.initData.chatHistoryContent && this.initData.chatHistory != null) {
            const chatStatus = JSON.parse(this.initData.chatHistory.toString())[this.initData.playerPriority!.toLowerCase()];
            chatStatus && chatStatus.toLowerCase() == 'on' && this.newAccountMenuService.getMenuVersion() != 1
                ? (this.showchathistory = true)
                : (this.showchathistory = false);
        }
    }

    goToContactOptions(source: string) {
        switch (source) {
            case 'complaintform':
                if (!this.initData.enableGreeceComplaintForm) break;
                break;
            case 'lostPasswordSuccessScreen':
                this.optionsScreen = true;
                break;
            default:
        }
    }

    gotoLastKnownProduct(sectionName: string = '', action: string = '') {
        const vipStatus = this.initData.isVipUser ? 'VIP' : 'nonVIP';
        if (this.optionsScreen && this.initData.enableHelpAndContactPage && this.initData.isVipUser) {
            sectionName = 'Options';
        }
        if (sectionName === 'FAQ' && action === 'NO') {
            this.captureHelpAndContactTracking(`${sectionName}_${this.currentSelectedSubCatergoryId}_${action}`);
            for (let i = 0; i < this.subCategoryList.length; i++) {
                if (this.subCategoryList[i].value.metadata.id.itemName === this.currentSelectedSubCatergoryId) {
                    this.subCategoryList[i].checked = false;
                    this.selectedSubCategory = false;
                    this.newAccountMenuService.scrollToTop();
                    return;
                }
            }
        } else {
            if (sectionName !== '') {
                this.captureEventTracking(`Help_Contact_HP_${vipStatus}_${sectionName}_${action}_Clicked`);
            }
        }
        if (
            this.landingPage[this.initData.playerPriority.toLowerCase()].toLowerCase() !== 'contactoptionsscreen' &&
            action === 'Back' &&
            this.navigation.location.search.get('source') != 'mohinterceptor'
        ) {
            if (this.helpAndContactData.showButtons) {
                this.optionsScreen = false;
                this.helpAndContactData.showButtons = false;
                if (this.currentSelectedCategoryId !== null) {
                    this.initData.newCategoriesList.map((category: any) => {
                        if (category.id === this.currentSelectedCategoryId) {
                            category.checked = true;
                        } else {
                            category.checked = false;
                        }
                    });
                    this.subCategoryList.map((subCategory: any) => {
                        if (subCategory.value.metadata.id.itemName === this.currentSelectedSubCatergoryId) {
                            subCategory.checked = true;
                        } else {
                            subCategory.checked = false;
                        }
                    });
                }
                return;
            }
        }
        if (
            this.navigation.location.search.has('source') &&
            (this.navigation.location.search.get('source') === 'documentupload' || this.navigation.location.search.get('source') === 'interceptor')
        ) {
            this.navigation.goToLastKnownProduct({ forceHistoryBack: false });
        } else if (this.navigation.location.search.get('source') === 'mohinterceptor') {
            if (this.nativeAppService.isNativeApp) {
                this.loginNavigationService.goToHome();
            } else this.navigation.goToLastKnownProduct();
        } else {
            this.navigation.goToLastKnownProduct({ forceHistoryBack: true });
        }
    }
    selectedCategoryList(selectedItem: any) {
        this.scrollService.scrollTo('#Category', 500, -130);
        this.categorySelected = true;
        if (selectedItem.id !== this.currentSelectedCategoryId) {
            this.subCategoryList = [];
            this.selectedSubCategory = false;
            this.subCategory = selectedItem.category;
            this.currentSelectedCategory = selectedItem.category;
            this.currentSelectedCategoryId = selectedItem.id;
            if (selectedItem.category.parent != undefined) this.currentSelectedCategoryName = selectedItem.category.parent.title;

            this.subCategory.childs.map((child: any) => {
                const objectCategory: { [key: string]: string } = {};
                objectCategory['value'] = child;
                objectCategory['title'] = child.faqTitle;
                this.subCategoryList.push(objectCategory);
            });
        }
        if (this.activatedRoute.snapshot.params['subcategory']) {
            this.subCategoryList
                .filter((subCategory: any) => this.activatedRoute.snapshot.params['subcategory'] == subCategory.value.metadata.id.itemName)
                .map((subCategory: any, index: any) => {
                    subCategory.checked = true;
                    if (this.initData.helpAndContactUxCleanUpEnabled) {
                        this.selectedSubCategoryId = '#contactSubRadio' + index;
                    }
                    this.selectedSubCategoryList(subCategory);
                });
        }
        this.capturePageLoadTracking('Help_Contact_HP_nonVIP_Section2');
        this.captureHelpAndContactTracking(`WCWH_${this.currentSelectedCategoryId}`);
        this.screenName = 'Section2';
    }

    selectedSubCategoryList(selectedSubCategory: any, event?: Event) {
        let selectedSubCategoryElement: any;

        if (selectedSubCategory.title == 'Official Complaint') {
            this.tracking.triggerEvent('Event.HelpAndContact', { 'page.HelpAndContact': 'FAQ_Official_Complaint_Option_Click' });
        }

        if (event) selectedSubCategoryElement = event.target as HTMLInputElement;
        if (!this.initData.helpAndContactUxCleanUpEnabled) {
            this.scrollService.scrollTo('#SubCategory', 500, -130);
        }
        this.currentSelectedSubCatergoryId = selectedSubCategory.value.metadata.id.itemName;
        this.currentSelectedSubCategory = selectedSubCategory;
        this.selectedSubCategory = true;
        setTimeout(() => {
            if (selectedSubCategoryElement) this.scrollService.scrollTo(selectedSubCategoryElement, 500, -80);
        }, 200);
        this.capturePageLoadTracking('Help_Contact_HP_nonVIP_Section3');
        this.captureHelpAndContactTracking(`FAQ_${this.currentSelectedSubCatergoryId}`);
        this.screenName = 'Section3';
    }

    goToOptions() {
        this.captureHelpAndContactTracking(`FAQ_${this.currentSelectedSubCatergoryId}_YES`);
        this.screenName = 'Section4_YES';
        this.optionsScreen = true;
    }

    enableEmailScreen(showEmail: boolean) {
        this.showEmail = showEmail;
    }

    disableEmailScreen(goToContactOptionScreen: boolean) {
        this.showEmail = false;
        this.optionsScreen = goToContactOptionScreen;
        this.helpAndContactData.showEmailScreen = false;
        this.helpAndContactData.showButtons = true;
    }

    emailScreenLoad(data: any) {
        this.emailScreenContactData = data;
    }

    enablePhoneScreen(data: any) {
        this.phoneScreenContactData = data;
        this.showPhone = data.showPhone;
    }

    disablePhoneScreen(showPhone: boolean) {
        this.showPhone = showPhone;
        this.optionsScreen = true;
        this.helpAndContactData.showButtons = false;
    }

    faqLinkClick(el: any) {
        if (el.target.nodeName.toLowerCase() === 'a') {
            this.captureEventTracking('Help_Contact_HP_nonVIP_Section3_Link_Clicked');
        }
    }
    isNullOrUndefined(str: string): boolean {
        if (str !== undefined && str !== null && str.length > 0) {
            return false;
        }
        return true;
    }
    ngAfterViewInit() {
        if (this.activatedRoute.snapshot.params['category'] && !this.activatedRoute.snapshot.params['subcategory']) {
            this.scrollService.scrollTo('#Category', 500, -130);
        } else if (this.activatedRoute.snapshot.params['category'] && this.activatedRoute.snapshot.params['subcategory']) {
            if (this.initData.helpAndContactUxCleanUpEnabled) {
                setTimeout(() => {
                    if (this.selectedSubCategoryId) this.scrollService.scrollTo(this.selectedSubCategoryId, 500, -80);
                }, 200);
            } else {
                this.scrollService.scrollTo('#SubCategory', 500, -130);
            }
        }
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    goToDocumentUpload(buttonName: string) {
        const trackingEvent: TrackingEvent = {
            CategoryEvent: 'hcc',
            LabelEvent: 'article',
            ActionEvent: 'click',
            PositionEvent: 'bottom of the page',
            LocationEvent: 'article page',
            EventDetails: buttonName,
            UrlClicked: this.windowRef.nativeWindow.location.href,
            HccCategory: this.currentSelectedCategoryName,
            HccArticle: this.currentSelectedSubCategory.title,
        };
        this.portalTrackingService.trackEvents(trackingEvent, '', EventNameConst.HelpAndContact);
        const uploadDocumentLink =
            this.initData.helpContactContent.messages.VerifyNowPreFooterLink +
            '?source=contactarticle&category=' +
            this.currentSelectedCategoryName +
            '&article=' +
            this.currentSelectedSubCategory.title;
        if (!this.user.isAuthenticated) {
            this.loginNavigationService.goToLogin({ appendReferrer: uploadDocumentLink });
            return;
        } else {
            return this.navigation.goTo(uploadDocumentLink);
        }
    }
    goToHistory() {
        this.tracking.triggerEvent('Event.HCC', {
            'component.CategoryEvent': 'hcc',
            'component.LabelEvent': 'chat history',
            'component.ActionEvent': 'click',
            'component.PositionEvent': 'suggestions',
            'component.LocationEvent': 'homepage',
            'component.EventDetails': 'chat history option',
            'component.URLClicked': 'not applicable',
            'component.hccCategory': 'not applicable',
            'component.hccArticle': 'not applicable',
        });
        this.portalNavigation.navigate('/chathistory');
    }

    private captureEventTracking(eventName: string) {
        this.tracking.triggerEvent('Event.Functionality.HelpContact', { 'page.referringAction': eventName });
    }

    private captureHelpAndContactTracking(eventName: string) {
        this.tracking.triggerEvent('Event.HelpAndContact', { 'page.HelpAndContact': eventName });
    }

    private capturePageLoadTracking(eventName: string) {
        this.tracking.triggerEvent('pageView', { 'page.name': eventName });
    }
}
